<template>
  <widget>
    <widget-header @close="$emit('close')">Create New Tag </widget-header>
    <widget-body>
      <form class="row" @submit.prevent="update" ref="form">
        <div class="col">
          <div class="row">
            <div class="input-group" :class="colSize">
              <YInput v-model="tag.name" label="Name"></YInput>
            </div>
          </div>
          <br />

          <div class="row">
            <div class="input-group" :class="colSize">
              <SuperSelect
                title="Type"
                v-model="tag.type"
                :multiple="false"
                :options="typeOptions"
              ></SuperSelect>
            </div>
          </div>
          <br />
        </div>
      </form>
    </widget-body>
    <widget-footer class="bg-gray-100 py-2 px-4 text-right">
      <YButton
        class="btn btn-blue"
        :is-loading="isSubmitting"
        @click="create"
        @keydown.enter="create"
        >Create Tag</YButton
      >
    </widget-footer>
    <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
    ></ValidationErrors>
  </widget>
</template>

<script>
import SuperSelect from '@/components/ui/Superselect.vue'
import CREATE_TAG_MUTATION from '@/graphql/Tag/CreateTagMutation.gql'
import TAG_TYPES_QUERY from '@/graphql/Tag/TagTypesQuery.gql'
import ValidationErrorsMixin from '@/mixins/ValidationErrorsMixin'
import TagDefaultColors from '@/mixins/TagDefaultColours.js'

export default {
  mixins: [ValidationErrorsMixin, TagDefaultColors],

  props: {},
  components: {
    SuperSelect
  },
  apollo: {
    tagTypes: {
      query: TAG_TYPES_QUERY,
      result(result) {
        this.typeOptions = result.data.tagTypes
      }
    }
  },
  data() {
    return {
      tag: {},
      isSubmitting: false,
      colSize: 'col-xl-3 col-lg-6',
      colSize2: 'col-xl-6 col-lg-12',
      typeOptions: []
    }
  },
  watch: {},
  computed: {},
  methods: {
    create() {
      this.isSubmitting = true

      let input = {
        name: this.tag.name,
        color: this.tagDefaultColour(this.tag.type),
        type: this.tag.type
      }

      this.$apollo
        .mutate({
          mutation: CREATE_TAG_MUTATION,
          variables: {
            input: input
          }
        })
        .then(() => {
          this.clearValidationErrors()
          this.$events.emit('refreshTags')
          this.$toastr.s('Tag Created', 'Success!')
          this.$emit('close')
        })
        .catch(error => {
          this.setValidationErrors(error)
          this.isSubmitting = false

          console.log(error)
        })
    }
  },
  close() {
    this.$emit('close')
  },
  mounted() {},
  updated() {}
}
</script>
